import DocumentInfo from './DocumentInfo';

export default DocumentInfo;